import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

// https://pixel.southjersey.aaa.com/v1/ticHmsT2nwyjXegPz/00/

export type PixelParams = {
  sessionId: string | null; // sessionId
  environment: 'prod' | 'test' | 'dev' | string; // <prod|test|dev>,
  clubId: string; // @clubId=071,
  feature: 'offer' | 'join' | 'renew' | 'myAccount' | string; // <join|renew|myAccount|...>
  target: 'pricePreview' | 'join' | 'confirmation' | string; // p<pricePreview|join|confirmation>,
  event: 'page' | string; // page
  result: 'ok' | 'no'; // ok

  timestamp: string; // @timestamp=<encodeURICompontent(dateIsoString())|2025-10-09T21%3A02%3A38.951Z>,
  application: string; // joinRenew
  component: string; // jrAngular
};

@Injectable({ providedIn: 'root' })
export class PixelService {
  http = inject(HttpClient);

  events(params: Partial<PixelParams>) {
    const { pixelUrl } = environment;

    if (!pixelUrl) return;

    const newParams: Partial<PixelParams> = {
      ...params,
      timestamp: encodeURIComponent(new Date().toISOString()),
      application: 'joinRenew',
      component: 'jrAngular',
    };
    this.http.get(pixelUrl + `${this.formatParams(newParams)}`).subscribe();
  }

  formatParams(obj: Record<string, any>): string {
    return Object.entries(obj)
      .map(([key, value]) => `@${key}=${value}`)
      .join(',');
  }
}
